@if (isLoading) {
<div class="app-main">
    <lokos-global-header></lokos-global-header>
    <mat-sidenav-container [hasBackdrop]="false" [autosize]="true">
        <mat-sidenav #drawer mode="side" [opened]="true">
            <lokos-side-menu />
        </mat-sidenav>
        <mat-sidenav-content>
            @if (userProfile) {
            <lokos-header></lokos-header>
            }
            <div class="outlet-area" id='outlet'>
                <router-outlet></router-outlet>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
}